/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./required-input.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import __noop from '@atlaskit/ds-lib/noop';
var styles = null;
var RequiredInput = function RequiredInput(_ref) {
  var name = _ref.name,
    onFocus = _ref.onFocus;
  return /*#__PURE__*/React.createElement("input", {
    required: true,
    name: name,
    tabIndex: -1,
    "aria-hidden": "true"
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: ax(["_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw", "-requiredInput"]),
    onFocus: onFocus,
    // Prevent `Switching from uncontrolled to controlled` error
    value: "",
    onChange: __noop
  });
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default RequiredInput;